import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import ModulePermissionSelector from './ModulePermissionSelector';
import { moduleService } from '../services/moduleService';
import './ModulePermissionDialog.css';

const UserModulePermissionsPage = () => {
  const { userId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [modules, setModules] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const employeeName = location.state?.employeeName || '';
  const username = location.state?.username || '';

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [modsRes, permsRes] = await Promise.all([
          moduleService.getModulesWithSubModules(),
          moduleService.getUserPermissions(userId),
        ]);
        const mods = (modsRes.data || modsRes) ?? [];
        setModules(mods);

        const perms = (permsRes.data || permsRes) ?? [];
        const byCode = {};
        perms.forEach((p) => {
          if (p.moduleCode) {
            byCode[p.moduleCode] = {
              moduleCode: p.moduleCode,
              moduleId: p.moduleId,
              canView: p.canView,
              canCreate: p.canCreate,
              canUpdate: p.canUpdate,
              canDelete: p.canDelete,
              canApprove: p.canApprove,
            };
          }
        });
        setPermissions(byCode);
      } catch (e) {
        console.error('Erreur chargement permissions modules', e);
        setError("Erreur lors du chargement des permissions de l'utilisateur");
      } finally {
        setLoading(false);
      }
    };
    if (userId) {
      loadData();
    }
  }, [userId]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const list = Object.values(permissions || {});
      await moduleService.updateUserPermissions(userId, list);
      alert('Permissions mises à jour avec succès.');
      navigate(-1);
    } catch (e) {
      console.error('Erreur sauvegarde permissions modules', e);
      setError("Erreur lors de la sauvegarde des permissions.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="employee-management">
      <div className="management-header">
        <h2>
          Permissions modules – Utilisateur #{userId}
          {username && ` (${username})`}
          {employeeName && ` – ${employeeName}`}
        </h2>
      </div>

      {error && (
        <div className="error-banner">
          <span>{error}</span>
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      {loading ? (
        <div className="loading">Chargement des modules et permissions...</div>
      ) : (
        <ModulePermissionSelector
          modules={modules}
          value={permissions}
          onChange={setPermissions}
        />
      )}

      <div className="modal-actions" style={{ marginTop: '1rem' }}>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate(-1)}
          disabled={saving}
        >
          Annuler
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
};

export default UserModulePermissionsPage;


